import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import "./Subscription.css";
import API_BASE_URL from "../config/api";

function SubscriptionPage() {

  const [groups, setGroups] = useState({});

  const [userId, setUserId] = useState(null);

  const navigate = useNavigate();

  /* LOAD USER */

  useEffect(() => {

    const storedUser =
      JSON.parse(sessionStorage.getItem("user"));

    setUserId(storedUser?.id || null);

  }, []);

  /* FETCH PLANS */

  useEffect(() => {

    axios
      .get(`${API_BASE_URL}/get_subscription_plans.php`)
      .then((res) => {

        if (res.data.success) {

          setGroups(res.data.groups);
        }

      })
      .catch((err) => console.error(err));

  }, []);

  /* LOGIN CHECK */

  const ensureLoggedIn = async () => {

    if (userId) return true;

    const result = await Swal.fire({

      title: "Not Logged In",

      text: "Please login or register to continue.",

      icon: "warning",

      showConfirmButton: true,

      showDenyButton: true,

      showCloseButton: true,

      confirmButtonText: "Login",

      denyButtonText: "Register",

      confirmButtonColor: "#0d6efd",

      denyButtonColor: "#198754",
    });

    if (result.isConfirmed)
      navigate("/login");

    if (result.isDenied)
      navigate("/signup");

    return false;
  };

  /* SELECT PLAN */

 const handleChoose = async (plan) => {

  // Publish check
  if (plan.is_publish !== "Y") {
    Swal.fire({
      icon: "warning",
      title: "Coming Soon",
      text: "This subscription plan is not available yet."
    });
    return;
  }

  const ok = await ensureLoggedIn();

  if (!ok) return;

  if (Number(plan.price) === 0) {

    Swal.fire({
      title: "Activate Free Plan?",
      text: `Do you want to activate ${plan.name}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Activate",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#042852"
    }).then(async (result) => {

      if (!result.isConfirmed) return;

      try {

        const orderRes = await axios.post(
          `${API_BASE_URL}/create_razorpay_order.php`,
          {
            user_id: userId,
            amount: 0,
            plan_id: plan.id,
            free_plan: 1
          }
        );

        if (!orderRes.data.success) {
          Swal.fire({
            icon: "error",
            title: "Failed",
            text: orderRes.data.message
          });
          return;
        }

        const saveRes = await axios.post(
          `${API_BASE_URL}/save_user_subscription.php`,
          {
            payment_order_id:
              orderRes.data.payment_order_id,
            razorpay_order_id:
              "FREE_PLAN",
            payment_id:
              "FREE_" + Date.now()
          }
        );

        if (saveRes.data.success) {

          Swal.fire({
            icon: "success",
            title: "Free Plan Activated!",
            timer: 1500,
            showConfirmButton: false
          });

          navigate("/studentdashboard");

        } else {

          Swal.fire({
            icon: "error",
            title: "Failed",
            text: saveRes.data.message
          });
        }

      } catch (err) {

        console.log(err);

        Swal.fire({
          icon: "error",
          title: "Server Error",
          text: "Unable to activate free plan"
        });
      }
    });

  } else {

    openRazorpay(plan);

  }
};

  /* RAZORPAY */

  const openRazorpay = async (plan) => {

    try {

      /* CREATE ORDER */

      const orderRes = await axios.post(
        `${API_BASE_URL}/create_razorpay_order.php`,
        {
          user_id: userId,
          amount: plan.price,
          plan_id: plan.id
        }
      );

      /* FAILED */

      if (!orderRes.data.success) {

        Swal.fire({
          icon: "error",
          title: "Order Failed",
          text:
            orderRes.data.message ||
            "Unable to create order"
        });

        return;
      }

      /* ORDER DATA */

      const order =
        orderRes.data.order;

      const paymentOrderId =
        orderRes.data.payment_order_id;

      /* USER DATA */

      const storedUser =
        JSON.parse(
          sessionStorage.getItem("user")
        ) || {};

      /* OPTIONS */

      const options = {

        key:
          process.env.REACT_APP_RAZORPAY_KEY,

        amount:
          order.amount,

        currency:
          "INR",

        name:
          "The Pilot Guide",

        description:
          plan.name,

        image:
          process.env.REACT_APP_LOGO_URL,

        order_id:
          order.id,

        prefill: {

          name:
            storedUser.name || "",

          email:
            storedUser.email_id || "",

          contact:
            storedUser.mobile_no || ""
        },

        readonly: {
          contact: true,
          email: true
        },

        notes: {

          user_id: userId,

          plan_id: plan.id,

          website:
            "thepilotguide.in"
        },

        theme: {
          color: "#042852"
        },

        /* PAYMENT SUCCESS */

        handler: async function (response) {

          try {

            const saveRes =
              await axios.post(
                `${API_BASE_URL}/save_user_subscription.php`,
                {

                  payment_order_id:
                    paymentOrderId,

                  razorpay_order_id:
                    response.razorpay_order_id,

                  payment_id:
                    response.razorpay_payment_id
                }
              );

            if (saveRes.data.success) {

              Swal.fire({
                icon: "success",
                title: "Payment Successful",
                text:
                  "Subscription Activated",
                timer: 2000,
                showConfirmButton: false
              });

              navigate("/studentdashboard");

            } else {

              Swal.fire({
                icon: "error",
                title: "Save Failed",
                text:
                  saveRes.data.message
              });
            }

          } catch (err) {

            console.log(err);

            Swal.fire({
              icon: "error",
              title: "Server Error",
              text:
                "Failed to save subscription"
            });
          }
        }
      };

      /* OPEN CHECKOUT */

      const rzp1 =
        new window.Razorpay(options);

      /* PAYMENT FAILED */

      rzp1.on(
        "payment.failed",
        async function (response) {

          try {

            await axios.post(
              `${API_BASE_URL}/update_failed_payment.php`,
              {

                razorpay_order_id:
                  response.error.metadata.order_id,

                payment_id:
                  response.error.metadata.payment_id || "",

                status:
                  "failed"
              }
            );

          } catch (err) {

            console.log(err);
          }

          Swal.fire({

            icon: "error",

            title: "Payment Failed",

            html: `
              <b>${response.error.description}</b><br/>
              Error Code: ${response.error.code}<br/>
              Order ID: ${response.error.metadata.order_id}<br/>
              Payment ID: ${
                response.error.metadata.payment_id || ""
              }
            `
          });
        }
      );

      /* OPEN */

      rzp1.open();

    } catch (error) {

      console.log(error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          "Unable to start payment"
      });
    }
  };

  /* GROUP ORDER */

 const GROUP_ORDER = [
  "all_access",
  "individual"
];

  /* TITLES */

  const getGroupTitle = (type) => {

    if (type === "individual")
      return "Subject Focused Preparation";

    if (type === "all_access")
      return "All Access Packages";

    return type;
  };

  return (

    <section className="py-15">

      <div className="container">

        {GROUP_ORDER
          .filter(type => groups[type])
          .map((type) => (

          <div
            key={type}
            className="mb-5 pt-4"
          >

            <h3 className="text-blue mb-4">
              {getGroupTitle(type)}
            </h3>

            <div className="row g-4">

             {groups[type].map((plan) => {

  const isPublished = plan.is_publish === "Y";

  return (
    <div
      key={plan.id}
      className="col-6 col-md-6 col-lg-4"
    >
      <div
        className={`poster-card ${!isPublished ? "disabled-plan" : ""}`}
        onClick={() => {
          if (isPublished) {
            handleChoose(plan);
          } else {
            Swal.fire({
              icon: "info",
              title: "Coming Soon",
              text: `${plan.name} is not available yet.`
            });
          }
        }}
      >

        <img
          src={`${process.env.PUBLIC_URL}${plan.image}`}
          alt={plan.name}
          className="w-100"
        />

        {!isPublished && (
          <div className="coming-soon-overlay">
            COMING SOON
          </div>
        )}

      </div>
    </div>
  );
})}

            </div>

          </div>
        ))}

      </div>

    </section>
  );
}

export default SubscriptionPage;